export const email = {
  title: 'Confirmá tu e-mail',
  body1: 'Se envió un código de verificación a la dirección:',
  body2: 'Seguí las instrucciones del email y luego presioná continuar.',
  buttonResend: 'Reenviar',
  buttonContinue: 'Continuar',
}

export const phone = {
  title: 'Agregá un teléfono',
  body1: 'Ingresá tu número de teléfono',
  label1: 'Número de teléfono',
  button1: 'Enviar código',
  body2: 'Ingresá el código recibido',
  label2: 'Código',
  button2: 'Atrás',
  button3: 'Continuar',
}



// WEBPACK FOOTER //
// ./src/sections/missingInfo/text.js